import React from 'react';
import styled from 'styled-components';
import Checkbox from '../../../shared/Checkbox';

interface Props {
  checked: boolean;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  dataTestId?: string;
}

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
`;

const RouteCheckbox: React.FC<Props> = ({
  checked,
  value,
  onChange,
  dataTestId = 'checkbox-route',
}) => {
  const handleChange = (isChecked: boolean) => {
    const syntheticEvent = {
      target: {
        checked: isChecked,
        value,
      },
      stopPropagation: () => {},
    } as React.ChangeEvent<HTMLInputElement>;

    onChange(syntheticEvent);
  };

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <CheckboxContainer onClick={handleClick}>
      <Checkbox
        checked={checked}
        onChange={handleChange}
        size="small"
        inputProps={{
          value,
          'data-cy': dataTestId,
        }}
      />
    </CheckboxContainer>
  );
};

export default RouteCheckbox;

